(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["core7-compare"] && !Shopify.designMode) return;
  try {
    
  // Mobile competitor toggle: pick which competitor column sits beside CORE7.
  // Adds/removes .is-showing-im8 on the section; the CSS handles the rest. Has
  // no effect on tablet/desktop, where the toggle is hidden and the column-hiding
  // rules live only inside the mobile media query.
  document.addEventListener('click', (event) => {
    const option = event.target.closest('.core7-compare__competitor-option');
    if (!option) return;

    const section = option.closest('.core7-compare-section');
    if (!section) return;

    section.classList.toggle('is-showing-im8', option.dataset.compareCompetitor === 'im8');

    section.querySelectorAll('.core7-compare__competitor-option').forEach((button) => {
      const isActive = button === option;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  });

  // Supplement Facts lightbox: open/close, adult/kids switch, layout-based zoom
  // with pinch/pan on touch and drag-to-scroll on desktop.
  (() => {
    const ZOOM_MIN = 1;
    const ZOOM_MAX = 4;
    const ZOOM_STEP = 0.25;

    const roots = document.querySelectorAll('[data-core7-facts]');
    if (!roots.length) return;

    const touchDistance = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    const touchMidpoint = (a, b) => ({
      x: (a.clientX + b.clientX) / 2,
      y: (a.clientY + b.clientY) / 2,
    });

    roots.forEach((root) => {
      const dialog = root.querySelector('[data-facts-dialog]');
      if (!dialog) return;

      const image = dialog.querySelector('[data-facts-image]');
      const viewport = dialog.querySelector('[data-facts-viewport]');
      const stage = dialog.querySelector('[data-facts-stage]');
      const zoomLevel = dialog.querySelector('[data-facts-zoom-level]');
      const zoomInBtn = dialog.querySelector('[data-facts-zoom-in]');
      const zoomOutBtn = dialog.querySelector('[data-facts-zoom-out]');
      const resetBtn = dialog.querySelector('[data-facts-reset]');
      const switchButtons = Array.from(dialog.querySelectorAll('[data-facts-switch]'));

      let activeKey = image && image.getAttribute('data-src-adult') ? 'adult' : 'kids';
      let zoom = ZOOM_MIN;
      let dragging = false;
      let dragStartX = 0;
      let dragStartY = 0;
      let scrollStartX = 0;
      let scrollStartY = 0;
      let ignoreClick = false;
      let pinchActive = false;
      let pinchStartDistance = 0;
      let pinchStartZoom = ZOOM_MIN;
      let pinchRaf = 0;
      let pendingPinch = null;
      let fitRaf = 0;

      const getBaseWidth = () => {
        if (!viewport || viewport.clientWidth < 40) return 0;
        const styles = window.getComputedStyle(stage || viewport);
        const padL = parseFloat(styles.paddingLeft) || 0;
        const padR = parseFloat(styles.paddingRight) || 0;
        return Math.max(0, viewport.clientWidth - padL - padR);
      };

      const updateChrome = () => {
        if (zoomLevel) zoomLevel.textContent = `${Math.round(zoom * 100)}%`;
        if (zoomOutBtn) zoomOutBtn.disabled = zoom <= ZOOM_MIN;
        if (zoomInBtn) zoomInBtn.disabled = zoom >= ZOOM_MAX;
        if (resetBtn) resetBtn.disabled = zoom <= ZOOM_MIN;
      };

      const isDialogOpen = () => dialog.open === true || dialog.hasAttribute('open');

      // Soft default: clear inline sizing so CSS max-width:100% fits the dialog.
      // Never measure a closed dialog — clientWidth is 0 and locks in a tiny width.
      const clearImageSize = () => {
        zoom = ZOOM_MIN;
        if (image) {
          image.style.width = '';
          image.style.maxWidth = '';
          image.style.height = '';
          image.style.transform = '';
        }
        if (viewport) {
          viewport.scrollLeft = 0;
          viewport.scrollTop = 0;
        }
        updateChrome();
      };

      const fitToViewport = () => {
        zoom = ZOOM_MIN;
        if (!image || !viewport) return;

        const base = getBaseWidth();
        if (base > 0) {
          image.style.width = `${Math.round(base)}px`;
          image.style.maxWidth = 'none';
        } else {
          image.style.width = '';
          image.style.maxWidth = '';
        }
        image.style.height = 'auto';
        image.style.transform = 'none';
        viewport.scrollLeft = 0;
        viewport.scrollTop = 0;
        updateChrome();
      };

      const scheduleFit = () => {
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(() => {
          fitRaf = requestAnimationFrame(() => {
            fitRaf = 0;
            if (!isDialogOpen()) return;
            fitToViewport();
          });
        });
      };

      const openDialog = () => {
        clearImageSize();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        scheduleFit();
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      };

      // Keep the focal client point glued under the fingers / viewport center.
      const zoomTo = (nextZoom, focalClientX, focalClientY) => {
        if (!image || !viewport) return;

        const base = getBaseWidth();
        if (base <= 0) {
          scheduleFit();
          return;
        }

        const clamped = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, nextZoom));
        const prevRect = image.getBoundingClientRect();
        const hasSize = prevRect.width > 0 && prevRect.height > 0;
        const hasFocal = typeof focalClientX === 'number' && typeof focalClientY === 'number';

        const focalX = hasFocal ? focalClientX : prevRect.left + prevRect.width / 2;
        const focalY = hasFocal ? focalClientY : prevRect.top + prevRect.height / 2;
        const fx = hasSize ? (focalX - prevRect.left) / prevRect.width : 0.5;
        const fy = hasSize ? (focalY - prevRect.top) / prevRect.height : 0;

        zoom = clamped;
        image.style.width = `${Math.round(base * zoom)}px`;
        image.style.maxWidth = 'none';
        image.style.height = 'auto';
        image.style.transform = 'none';

        const nextRect = image.getBoundingClientRect();
        if (nextRect.width > 0 && nextRect.height > 0) {
          const shiftedX = nextRect.left + nextRect.width * fx;
          const shiftedY = nextRect.top + nextRect.height * fy;
          viewport.scrollLeft += shiftedX - focalX;
          viewport.scrollTop += shiftedY - focalY;
        }

        updateChrome();
      };

      const setPanel = (key) => {
        if (!image) return;
        const src = image.getAttribute(`data-src-${key}`);
        const alt = image.getAttribute(`data-alt-${key}`);
        if (!src) return;

        activeKey = key;
        if (image.getAttribute('src') !== src) {
          image.setAttribute('src', src);
        }
        if (alt) image.setAttribute('alt', alt);

        switchButtons.forEach((button) => {
          const isActive = button.getAttribute('data-facts-switch') === key;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (!isDialogOpen()) return;

        const onLoad = () => {
          scheduleFit();
          image.removeEventListener('load', onLoad);
        };
        if (image.complete) {
          scheduleFit();
        } else {
          image.addEventListener('load', onLoad);
        }
      };

      const flushPinch = () => {
        pinchRaf = 0;
        if (!pendingPinch || !pinchActive || pinchStartDistance <= 0) {
          pendingPinch = null;
          return;
        }

        const { distance, x, y } = pendingPinch;
        pendingPinch = null;
        const nextZoom = pinchStartZoom * (distance / pinchStartDistance);
        zoomTo(nextZoom, x, y);
      };

      const queuePinch = (distance, x, y) => {
        pendingPinch = { distance, x, y };
        if (pinchRaf) return;
        pinchRaf = requestAnimationFrame(flushPinch);
      };

      root.addEventListener('click', (event) => {
        if (ignoreClick) {
          ignoreClick = false;
          return;
        }

        const opener = event.target.closest('[data-facts-open]');
        if (opener && root.contains(opener)) {
          event.preventDefault();
          setPanel(opener.getAttribute('data-facts-open') || 'adult');
          openDialog();
          return;
        }

        const closer = event.target.closest('[data-facts-close]');
        if (closer && dialog.contains(closer)) {
          closeDialog();
          return;
        }

        const switcher = event.target.closest('[data-facts-switch]');
        if (switcher && dialog.contains(switcher)) {
          setPanel(switcher.getAttribute('data-facts-switch') || 'adult');
          return;
        }

        if (event.target.closest('[data-facts-reset]') && dialog.contains(event.target)) {
          fitToViewport();
          return;
        }

        if (event.target.closest('[data-facts-zoom-in]') && dialog.contains(event.target)) {
          const rect = viewport ? viewport.getBoundingClientRect() : null;
          zoomTo(
            zoom + ZOOM_STEP,
            rect ? rect.left + rect.width / 2 : undefined,
            rect ? rect.top + rect.height / 2 : undefined
          );
          return;
        }

        if (event.target.closest('[data-facts-zoom-out]') && dialog.contains(event.target)) {
          const rect = viewport ? viewport.getBoundingClientRect() : null;
          zoomTo(
            zoom - ZOOM_STEP,
            rect ? rect.left + rect.width / 2 : undefined,
            rect ? rect.top + rect.height / 2 : undefined
          );
        }
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('close', () => {
        pendingPinch = null;
        if (pinchRaf) {
          cancelAnimationFrame(pinchRaf);
          pinchRaf = 0;
        }
        if (fitRaf) {
          cancelAnimationFrame(fitRaf);
          fitRaf = 0;
        }
        clearImageSize();
      });

      const onPointerDown = (event) => {
        if (!viewport) return;
        if (event.pointerType === 'touch') return;
        if (event.button != null && event.button !== 0) return;
        if (event.target.closest('button, a')) return;

        dragging = true;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        scrollStartX = viewport.scrollLeft;
        scrollStartY = viewport.scrollTop;
        viewport.classList.add('is-panning');
        if (viewport.setPointerCapture && event.pointerId != null) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (error) {
            /* ignore capture failures */
          }
        }
      };

      const onPointerMove = (event) => {
        if (!dragging || !viewport) return;
        const dx = event.clientX - dragStartX;
        const dy = event.clientY - dragStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) ignoreClick = true;
        viewport.scrollLeft = scrollStartX - dx;
        viewport.scrollTop = scrollStartY - dy;
      };

      const onPointerUp = () => {
        if (!dragging) return;
        dragging = false;
        if (viewport) viewport.classList.remove('is-panning');
      };

      const onTouchStart = (event) => {
        if (!viewport) return;
        if (event.target.closest('button, a')) return;

        if (event.touches.length === 2) {
          event.preventDefault();
          pinchActive = true;
          dragging = false;
          pinchStartDistance = touchDistance(event.touches[0], event.touches[1]);
          pinchStartZoom = zoom;
          pendingPinch = null;
          if (pinchRaf) {
            cancelAnimationFrame(pinchRaf);
            pinchRaf = 0;
          }
          viewport.classList.remove('is-panning');
          return;
        }

        if (event.touches.length === 1 && !pinchActive) {
          dragging = true;
          dragStartX = event.touches[0].clientX;
          dragStartY = event.touches[0].clientY;
          scrollStartX = viewport.scrollLeft;
          scrollStartY = viewport.scrollTop;
          viewport.classList.add('is-panning');
        }
      };

      const onTouchMove = (event) => {
        if (!viewport) return;

        if (pinchActive && event.touches.length === 2) {
          event.preventDefault();
          if (pinchStartDistance <= 0) return;
          const mid = touchMidpoint(event.touches[0], event.touches[1]);
          queuePinch(touchDistance(event.touches[0], event.touches[1]), mid.x, mid.y);
          return;
        }

        if (dragging && event.touches.length === 1) {
          event.preventDefault();
          const touch = event.touches[0];
          const dx = touch.clientX - dragStartX;
          const dy = touch.clientY - dragStartY;
          if (Math.abs(dx) > 3 || Math.abs(dy) > 3) ignoreClick = true;
          viewport.scrollLeft = scrollStartX - dx;
          viewport.scrollTop = scrollStartY - dy;
        }
      };

      const onTouchEnd = (event) => {
        if (event.touches.length < 2) {
          if (pinchActive) {
            if (pinchRaf) {
              cancelAnimationFrame(pinchRaf);
              pinchRaf = 0;
            }
            if (pendingPinch) flushPinch();
            updateChrome();
          }
          pinchActive = false;
          pinchStartDistance = 0;
          pendingPinch = null;
        }

        if (event.touches.length === 1) {
          dragging = true;
          dragStartX = event.touches[0].clientX;
          dragStartY = event.touches[0].clientY;
          scrollStartX = viewport.scrollLeft;
          scrollStartY = viewport.scrollTop;
          if (viewport) viewport.classList.add('is-panning');
          return;
        }

        if (event.touches.length === 0) {
          dragging = false;
          if (viewport) viewport.classList.remove('is-panning');
        }
      };

      if (viewport) {
        viewport.addEventListener('pointerdown', onPointerDown);
        viewport.addEventListener('pointermove', onPointerMove);
        viewport.addEventListener('pointerup', onPointerUp);
        viewport.addEventListener('pointercancel', onPointerUp);
        viewport.addEventListener('lostpointercapture', onPointerUp);
        viewport.addEventListener('touchstart', onTouchStart, { passive: false });
        viewport.addEventListener('touchmove', onTouchMove, { passive: false });
        viewport.addEventListener('touchend', onTouchEnd);
        viewport.addEventListener('touchcancel', onTouchEnd);
      }

      window.addEventListener('resize', () => {
        if (!dialog.open) return;
        const rect = viewport.getBoundingClientRect();
        zoomTo(zoom, rect.left + rect.width / 2, rect.top + rect.height / 2);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
